// extracted by mini-css-extract-plugin
export default {"list-song":"ChartsWeekItem_list-song__0BkR2"};